import React from 'react';
import { FileSpreadsheet } from 'lucide-react';
import BpuDetailedView from '../Achat/components/ClientDetail/BpuDetailedView';

const ClientPricingTailwind: React.FC = () => {
  return (
    <div className="h-screen flex flex-col bg-gradient-to-br from-slate-50 via-emerald-50/20 to-slate-50 dark:from-slate-950 dark:via-emerald-950/10 dark:to-slate-950">
      <div className="flex items-center justify-between px-3 py-3 sm:px-6 sm:py-4 bg-white/80 dark:bg-slate-900/80 backdrop-blur-xl border-b border-slate-200/50 dark:border-slate-700/50 shadow-lg">
        <div className="flex items-center gap-3 sm:gap-4">
          <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-emerald-500 via-teal-500 to-emerald-600 rounded-xl flex items-center justify-center shadow-lg">
            <FileSpreadsheet className="h-5 w-5 sm:h-6 sm:w-6 text-white" />
          </div>
          <div>
            <h1 className="text-xl sm:text-2xl font-bold text-slate-900 dark:text-slate-100">Bordereau de Prix</h1>
            <p className="text-xs sm:text-sm text-slate-500 dark:text-slate-400">Tarifs personnalisés (BPU)</p>
          </div>
        </div>
      </div>

      <div className="flex-1 overflow-auto px-3 py-3 sm:px-6 sm:py-6">
        <div className="bg-white dark:bg-slate-900 rounded-lg shadow-sm border border-slate-200 dark:border-slate-700 p-3 sm:p-6">
          <BpuDetailedView useMyEndpoint={true} />
        </div>
      </div>
    </div>
  );
};

export default ClientPricingTailwind;
